// extracted by mini-css-extract-plugin
module.exports = {"grid":"_2aBmj___List-module__grid","flex":"_3OZIT___List-module__flex"};